export default "__VITE_ASSET__qfqSqgRR__"